import { ChangeEvent } from 'react'

import { Icon } from 'common/components'

import './FileUpload.less'

interface FileUploadProps {
  fileChoosed: (file: File) => void
  accept?: string[]
  translate: (key: string) => string
}

const FileUpload = ({ fileChoosed, accept, translate }: FileUploadProps) => {
  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      fileChoosed(e.target.files[0])
    }
  }
  return (
    <label className="upload_document_button ant-btn">
      <input
        type="file"
        className="input_file"
        accept={accept ? accept.join(',') : '*'}
        onChange={handleFileChange}
        value=""
      />
      <Icon type="fa fa-upload" fontAwesome className="pr-8" />
      {translate('get-reimburse.request.upload-new-label')}
    </label>
  )
}

export default FileUpload
